const CASE_INBOX = '/model/caseInbox';
const VIEW_TICKET = '/form/:formId/:label';

export {
    CASE_INBOX,
    VIEW_TICKET
}